import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { CheckMarkIcon, MinusIcon } from '../../components/icons';
import styles from './input-toggle.scss';
import { handleEnterKeyUp } from '../../services/accessibility';

const InputToggle = ({ text, level, checked, disabled, onChange, ...props }) => {
  return (
    <label className={classNames(styles.label, { [styles.level1]: level === '1' })}>
      {text}
      <span
        className={classNames(styles.switch, styles.right)}
        tabIndex={!disabled && '0'}
        onKeyUp={handleEnterKeyUp(onChange)}
        role="checkbox"
        aria-checked={checked}
        aria-label={text}
      >
        <input
          className={styles.switchInput}
          type="checkbox"
          tabIndex="-1"
          disabled={disabled}
          onChange={onChange}
          checked={checked}
          {...props}
        />
        <label className={classNames(styles.switchLabel, 'button-background-color')}>
          <span className={classNames(styles.switchI, 'button-border-color')}>
            <CheckMarkIcon className={classNames(styles.checkedIcon, 'button-fill')}/>
            <MinusIcon className={classNames(styles.uncheckedIcon, 'button-fill')}/>
          </span>
        </label>
      </span>
    </label>
  );
};

InputToggle.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  text: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  level: PropTypes.string,
  disabled: PropTypes.bool,
};

export default InputToggle;



// WEBPACK FOOTER //
// ./app/components/input-toggle/input-toggle.js